import { render, staticRenderFns } from "./PedidosVendedores.vue?vue&type=template&id=76557fdf&scoped=true"
import script from "./PedidosVendedores.vue?vue&type=script&lang=js"
export * from "./PedidosVendedores.vue?vue&type=script&lang=js"
import style0 from "./PedidosVendedores.vue?vue&type=style&index=0&id=76557fdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76557fdf",
  null
  
)

export default component.exports